import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Cookies from 'universal-cookie';

import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { library } from '@fortawesome/fontawesome-svg-core'

import HeaderText from '../../components/communal/HeaderText';
import InteractionTimeout from '../../components/communal/InteractionTimeout';
import SetTitle from '../../components/communal/SetTitle';
import DestinationSwitch from '../../utilities/generic/DestinationSwitch';

import { formatDate, generateId, debounce, scrollElementToTop } from '../../utilities/generic/Common.js'

import { handleRadio, getAnonymousQuestionIds, renderQuestion, anonymousMessage, handleFeedbackChange, handleMultiSelectCheckbox, compileAnswers } from '../../utilities/generic/Forms.js'

library.add(fas, far)

class Feedback extends Component {

  constructor(props) {
    super(props);

    this.debouncedScrollElementToTop = debounce(scrollElementToTop, 1000);
    this.handleFeedbackChange = handleFeedbackChange.bind(this);
    this.handleMultiSelectCheckbox = handleMultiSelectCheckbox.bind(this);
    this.handleRadio = handleRadio.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.compileAnswers = compileAnswers.bind(this);
  }

  state = {
    answers: {},
    initialTime: new Date(),

    validDetails: false,
    errors: "",
    error: ""
  }

  handleSubmit(event) {
    if (Object.keys(this.state.answers).length > 0) {
      // perform client-side validation here, display errors if needed

      let anonymousQuestionIds = getAnonymousQuestionIds(this)

      var answer = null

      var answersWithAppIds = {}

      for (const key in this.state.answers) {
        answersWithAppIds[generateId()] = {
          question_id: key,
          answer: this.compileAnswers(key)
        }
      }

      if (this.props.location.state.direction === "arriving") {
        answer = {
          arriving_app_id: this.props.location.state.directional_app_id,
          answers: answersWithAppIds,
          anonymous_question_ids: anonymousQuestionIds,
          app_id: generateId(),
          version: process.env.REACT_APP_COMMIT_HASH,
          created_at: formatDate(new Date())
        }
      }
      else {
        answer = {
          leaving_app_id: this.props.location.state.directional_app_id,
          answers: answersWithAppIds,
          anonymous_question_ids: anonymousQuestionIds,
          app_id: generateId(),
          version: process.env.REACT_APP_COMMIT_HASH,
          created_at: formatDate(new Date())
        }
      }

      var answers = JSON.parse(localStorage.getItem("answers"))

      // Create answers array if it doesn't exist
      if (answers === null) {
        answers = []
      }

      // Append to answers array, and save to semi-permanent storage
      answers.push(answer)
      localStorage.setItem("answers", JSON.stringify(answers))
    }

    this.setState({validDetails: true})

    event.preventDefault();
  }

  render() {
    const cookies = new Cookies()
    const token = cookies.get('device_token')

    if (token === undefined) {
      return <Redirect to="/setup/user"/>
    }

    if (this.props.location.state === undefined) {
      return <Redirect to="/404" />
    }

    let profile = this.props.location.state.profile
    let direction = this.props.location.state.direction

    const destinationSwitch = new DestinationSwitch({ current_page: "feedback", profile: profile, direction: direction });

    if (this.state.validDetails) {
      return destinationSwitch.redirect()
    }

    const submit_button_value = destinationSwitch.buttonName()
    let feedbackTypes = this.props.location.state.feedbackTypes

    return (
      <div className="main-page feedback-page">
        <InteractionTimeout seconds={60} />

        <SetTitle title={"Feedback"} />
        <HeaderText />

        <div className="content">

          <div className="feedback">
            <form autoComplete="off" onSubmit={this.handleSubmit}>
              {feedbackTypes.map((feedback) => {
                const top_level_feedback_questions = feedback.feedback_questions.filter(feedback_question => !feedback_question.depends_on_question_id)

                if (top_level_feedback_questions.length !== 0) {
                  return (
                    <div className="feedback-type" key={feedback.id}>
                      { anonymousMessage(feedback.anonymous) }

                      <div className="feedback-title">{feedback.display}</div>

                      {top_level_feedback_questions.map(question =>
                        renderQuestion(question, feedback, this)
                      )}
                    </div>
                  )
                }
                else {
                  return(null)
                }
              })}

              <div className="submit-container">
                <input type="submit" value={submit_button_value} />
              </div>
            </form>
            
          </div>

        </div>
      </div>
    );
  }
}

export default Feedback;
